import * as deliveryTimesActions from '../actions/delivery-times.actions';
import { createReducer, on, Action } from '@ngrx/store';
import * as userActions from '@core/auth/@store/user/user.actions';

export interface State {
  savingActionsInProgress: number;
  deleteActionsInProgress: number;
}

export const initialState: State = {
  savingActionsInProgress: 0,
  deleteActionsInProgress: 0,
};

export const featureReducer = createReducer(
  initialState,
  on(
    deliveryTimesActions.createDeliveryTime,
    deliveryTimesActions.updateDeliveryTime,
    (state) => ({
      ...state,
      savingActionsInProgress: state.savingActionsInProgress + 1,
    })
  ),
  on(
    deliveryTimesActions.createDeliveryTimeSuccess,
    deliveryTimesActions.createDeliveryTimeFailed,
    deliveryTimesActions.updateDeliveryTimeSuccess,
    deliveryTimesActions.updateDeliveryTimeFailed,
    (state) => ({
      ...state,
      savingActionsInProgress: state.savingActionsInProgress - 1,
    })
  ),
  on(deliveryTimesActions.deleteDeliveryTime, (state) => ({
    ...state,
    savingActionsInProgress: state.deleteActionsInProgress + 1,
  })),
  on(
    deliveryTimesActions.deleteDeliveryTimeSuccess,
    deliveryTimesActions.deleteDeliveryTimeFailed,
    (state) => ({
      ...state,
      savingActionsInProgress: state.deleteActionsInProgress - 1,
    })
  ),
  on(userActions.setActiveCompany, () => initialState)
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
